import React from "react";
import useMediaQueries from "../../hooks/useMediaQueries";
import { IconButton, Tooltip, TableSortLabel, Avatar } from "@material-ui/core";
import { Link } from "react-router-dom";

import styled from "styled-components";
import {
    Edit as EditIcon,
    RemoveRedEye as ViewIcon,
    Delete as DeleteIcon,
    Done as YesIcon,
    Close as NoIcon,
} from "@material-ui/icons";

const LAYOUT_COLS = 24;
const CELL_SIZE = 100 / LAYOUT_COLS;

const TableHeadRow = styled.div`
    width: 100%;
    display: block;
    position: relative;
    border: 0px solid lightgray;
    border-radius: 6px;
    border-left: 6px solid rgba(0, 0, 0, 0);
    margin-bottom: 2px;
    padding: 4px;
`;
const ViewButton = {
    color: "#0188cc",
    border: "1px solid #0188cc",
    margin: 4,
};

const EditButton = { color: "#0188cc", border: "1px solid #0188cc", margin: 4 };

const DeleteButton = { color: "red", border: " 1px solid red", margin: 4 };

const TableHeadCell = styled.div`
    width: ${({ cols = 3 }) => {
        return cols * CELL_SIZE + "%";
    }};
    padding: 4px;
    padding-left: 20px;
    text-align: left;
    line-height: 100%;
    position: relative;
    font-weight: bold;
    display: inline-block;
`;
const TableDataRow = styled.div`
    width: 100%;
    display: flex;
    position: relative;
    border: 1px solid lightgray;
    border-radius: 6px;
    border-left: 6px solid #0188cc;
    margin-bottom: 2px;
    padding: 4px;
    align-items: center;
    background ${({ uneditable }) => {
        return uneditable ? "#eee" : "white";
    }}
`;
const TableDataCell = styled.div`
    width:${({ cols = 3 }) => {
        return cols * CELL_SIZE + "%";
    }}
    white-space: nowrap;
    padding:4px;
    
    padding-left:24px;
    text-align: left;
    line-height:100%;
    position:relative;
   overflow:hidden;vertical-align: middle;

    align-items:stretch;
    text-overflow: ellipsis;
`;
const TableContainer = styled.div`
    margin: 0;
    height: auto;
    width: 100%;
    padding: 0;
`;
const Table = styled.div`
    width: 100%;

    margin: 0;
    padding: 12px;
    background: white;
`;
function formatCell(value, cellType = "text") {
    switch (cellType) {
        case "text": {
            return value === "" ? "N/A" : value;
        }
        case "avatar": {
            return (
                <Avatar src={value} height="42px" width="42px" alt={value} />
            );
        }
        case "image": {
            return <img src={value} height="42px" width="auto" alt={value} />;
        }
        case "boolean": {
            return value === "yes" || value === "Yes" || value === true ? (
                <YesIcon style={{ color: "Green" }} />
            ) : (
                <NoIcon style={{ color: "Red" }} />
            );
        }
        default: {
            return value;
        }
    }
}
function GridHeadCell(
    { label, key, width, sortable, sortAs },
    sortTableKey,
    sortTableType,
    setSortTableKey,
    setSortTableAs,
    enableSorting,
    setSortTableType
) {
    return (
        <TableHeadCell cols={width}>
            {(sortable && enableSorting && (
                <Tooltip
                    title="Sort"
                    placement={"bottom-start"}
                    enterDelay={300}
                >
                    <TableSortLabel
                        active={sortTableKey === key}
                        direction={sortTableType || "asc"}
                        onClick={() => {
                            setSortTableKey(key);
                            setSortTableAs(sortAs);
                            switch (sortTableType) {
                                case "asc": {
                                    setSortTableType("desc");
                                    break;
                                }
                                case "desc": {
                                    setSortTableType("asc");
                                    break;
                                }
                                default: {
                                    return;
                                }
                            }
                        }}
                    >
                        {label}
                    </TableSortLabel>
                </Tooltip>
            )) ||
                label}
        </TableHeadCell>
    );
}
function TableList({
    permissions = false,
    listData = false,
    tableConfig = false,
    enableSorting = false,
    sortTableKey = false,
    sortTableType = false,
    setSortTableKey = false,
    setSortTableAs = false,
    setSortTableType = false,
    isReports = false,
    viewAction = false,
    editAction = false,
    deleteAction = false,
    showActions = true,
    showViewAction = true,
    showEditAction = true,
    showDeleteAction = true,
    customCellKeys = false,
    customCells = false,
    selectActionData = false,
    customActions = false,
}) {
    const mq = useMediaQueries();

    const cCellKeys = Array.isArray(customCellKeys) ? customCellKeys : [];
    return Array.isArray(listData) ? (
        <div style={{ width: "100%", overflow: "scrollX" }}>
            <Table>
                <TableContainer>
                    <TableHeadRow>
                        {tableConfig.map((cell) => {
                            return GridHeadCell(
                                cell,
                                sortTableKey,
                                sortTableType,
                                setSortTableKey,
                                setSortTableAs,
                                enableSorting,
                                setSortTableType
                            );
                        })}
                        {mq === "xl" && (
                            <TableHeadCell cols={6}>Actions</TableHeadCell>
                        )}
                    </TableHeadRow>
                    {listData.map((row, i) => {
                        let canRead = true,
                            canUpdate = true,
                            canDelete = true;
                        if (isReports) {
                            canRead = permissions[row.report_type].read;

                            canUpdate = permissions[row.report_type].update;
                            canDelete = permissions[row.report_type].delete;
                        } else {
                            canRead = permissions ? permissions.read : true;

                            canUpdate = permissions ? permissions.update : true;
                            canDelete = permissions ? permissions.delete : true;
                        }
                        return (
                            <TableDataRow key={i} uneditable={row.uneditable}>
                                {tableConfig.map((cell, ind) => {
                                    return (
                                        <TableDataCell
                                            cols={cell.width}
                                            key={ind}
                                        >
                                            <span
                                                style={{
                                                    lineHeight: "100%",
                                                    verticalAlign: "middle",
                                                }}
                                            >
                                                {" "}
                                                {cCellKeys.includes(cell.key)
                                                    ? customCells(row, cell.key)
                                                    : formatCell(
                                                          row[cell.key],
                                                          cell.keyType
                                                      )}
                                            </span>
                                        </TableDataCell>
                                    );
                                })}
                                {showActions && (
                                    <TableDataCell cols={6}>
                                        {canRead &&
                                            showViewAction &&
                                            !viewAction && (
                                                <Link to={row.view_route}>
                                                    <IconButton
                                                        style={ViewButton}
                                                    >
                                                        <Tooltip title="View">
                                                            <span>
                                                                <ViewIcon />
                                                            </span>
                                                        </Tooltip>
                                                    </IconButton>
                                                </Link>
                                            )}
                                        {canRead &&
                                            showViewAction &&
                                            viewAction && (
                                                <IconButton
                                                    style={ViewButton}
                                                    onClick={() =>
                                                        viewAction(row)
                                                    }
                                                >
                                                    <Tooltip title="View">
                                                        <span>
                                                            <ViewIcon />
                                                        </span>
                                                    </Tooltip>
                                                </IconButton>

                                            )}
                                        {canUpdate &&
                                            showEditAction &&
                                            !editAction && (
                                                <Link to={row.edit_route}>
                                                    <IconButton
                                                        style={EditButton}
                                                    >
                                                        {" "}
                                                        <Tooltip title="Edit">
                                                            <span>
                                                                {" "}
                                                                <EditIcon />
                                                            </span>
                                                        </Tooltip>
                                                    </IconButton>
                                                </Link>
                                            )}
                                        {canUpdate &&
                                            showEditAction &&
                                            editAction && (
                                                <IconButton
                                                    style={EditButton}
                                                    onClick={() =>
                                                        editAction(row)
                                                    }
                                                >

                                                    <Tooltip title="Edit">
                                                        <span>
                                                            {" "}
                                                            <EditIcon />
                                                        </span>
                                                    </Tooltip>
                                                </IconButton>
                                            )}
                                        {canDelete && showDeleteAction && (
                                            <IconButton
                                                onClick={() =>
                                                    deleteAction(row)
                                                }
                                                style={DeleteButton}
                                            >
                                                <Tooltip title="Delete">
                                                    <span>
                                                        <DeleteIcon />
                                                    </span>
                                                </Tooltip>
                                            </IconButton>
                                        )}
                                        {customActions &&
                                            Object.keys(
                                                typeof customActions ===
                                                    "object"
                                                    ? customActions
                                                    : customActions(row)
                                            ).map((f) => {
                                                return (
                                                    <IconButton
                                                        style={ViewButton}
                                                        onClick={() =>
                                                            selectActionData(
                                                                row,
                                                                f
                                                            )
                                                        }
                                                    >
                                                        {typeof customActions ===
                                                        "object" ? (
                                                            <Tooltip title={f}>
                                                                <span>
                                                                    {
                                                                        customActions[
                                                                            f
                                                                        ]
                                                                    }
                                                                </span>
                                                            </Tooltip>
                                                        ) : (
                                                            customActions(row)[
                                                                f
                                                            ]
                                                        )}
                                                    </IconButton>
                                                );
                                            })}
                                        {/* Action Buttons Go Here*/}
                                    </TableDataCell>
                                )}
                            </TableDataRow>
                        );
                    })}
                </TableContainer>
            </Table>
        </div>
    ) : (
        "Table Cannot Be Viewed Due To Incorrect Data Format, data should be formatted as an array."
    );
}
export default TableList;
